import isEmpty from 'lodash/isEmpty';

import type { RecommendationData } from 'chaika-frontend-types/frontend-cms';

import { SimpleList } from '@store/models/SimpleList';

export interface RecommendationListFilterParams {
    ids?: string[];
    end?: Date;
    parentEntryId?: string;
}

export class RecommendationList extends SimpleList<RecommendationData, RecommendationListFilterParams> {
    protected filterValue(
        recommendation: RecommendationData,
        { ids, parentEntryId, end }: RecommendationListFilterParams,
    ): boolean {
        return (
            (!isEmpty(recommendation.end)
                ? this.filterFilterValueBeforeFieldValue(recommendation, end, 'end')
                : true) &&
            this.filterFieldValueByArray(recommendation, ids, 'id') &&
            this.filterFieldValue(recommendation, parentEntryId, 'parentEntryId')
        );
    }
}
